import axios from "axios";
import { ChangeEvent, FC, useEffect, useState } from "react";
import { uploadImageContainerProps } from "../../types/types";
import UPloadImagePresentation from "./presentation/UPloadImagePresentation";
const UploadImageContainer: FC<uploadImageContainerProps> = ({
  onChangeImageUrlState,
  defaultImage,
  shop,
  hexShape
}) => {
  const [imageUrl, setImageUrl] = useState<string>(defaultImage!)
  const [loading, setLoading] = useState<boolean>(false)
  useEffect(() => {
    if (defaultImage) {
      setImageUrl(defaultImage)
    }
  }, [defaultImage])

  // const [uploadFile, { isLoading }] = useUploadFileMutation();

  const onChange = async (e: ChangeEvent<HTMLInputElement>) => {
    setLoading(true)

    const formData = new FormData()

    const file = e.target.files![0]
    const size = Number((file.size / 1024 / 1024).toFixed(2))
    if (file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png') {
      if (size < 2) {
        formData.append('file', file)

        try {
          const response = await axios.post(
            `${process.env.REACT_APP_API_URL}/api/upload-image/upload`,
            formData
          )

          setTimeout(() => {
            const urlGenarator = response.data.uri

            setImageUrl(urlGenarator)
            onChangeImageUrlState(urlGenarator)
            setLoading(false)
          }, 2000)
        } catch (error) {
          console.error(error)
        }
      } else {
        alert('file should less than 2MB')
        setLoading(false)
      }
    } else {
      alert('this is not image file')
      setLoading(false)
    }
  }

  return (
    <UPloadImagePresentation
      imageUrl={imageUrl}
      onChagne={onChange}
      shop={shop}
      hexShape={hexShape}
      loading={loading}
    />
  )
}

export default UploadImageContainer
